import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../components/AuthProvider";

/**
 * Wraps admin-only pages. Must be rendered *inside* <PrivateRoutes />
 * so authentication is already verified. This component only checks
 * the role stored in AuthProvider context.
 *
 * Accepted role value: 1  (superuser / administrator)
 * Any other value redirects to /landing.
 */
const AdminRoute = ({ children }) => {
  const { role } = useAuth();

  if (role !== 1) {
    return <Navigate to="/landing" replace />;
  }

  return children;
};

export default AdminRoute;
